import { useState, useEffect, useContext, useCallback, useRef } from "react";
import ReusableModal from "../../../AppPAges/ManageSettings/ReusableModal";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../../../common/ToastHandler";
import useSwal from "../../../../common/ReusableComponent/useSwal";
import AssetTable from "../../../AssetManagement/AssetsInventory/AssetTable";
import { ReusableInput } from "../../../../common/ReusableComponent/ReusableInput";
import { RegularButton } from "../../../../common/ReusableComponent/CustomButton";
import "./InventoryPO.css"
import StatusPill from "../../../../common/ReusableComponent/StatusPill";
import ActionButton from "../../../../common/ReusableComponent/ActionButton";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import { FiPackage } from "react-icons/fi";
import PaginatedSearchSelect from "../../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import PaginatedMultiSelect from "../../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedMultiSelect";
const InventoryPO = () => {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler();
  const { GetPaginatedData, Delete, Patch, Get, Post, getAPI, PostDataForm } = useApi();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [poData, setPoData] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewPoId, setViewPoId] = useState(null);
  const [poDetails, setPoDetails] = useState(null);
  const [showReceiveModal, setShowReceiveModal] = useState(false);
  const [receivePoItem, setReceivePoItem] = useState(null);

  const [receiveItems, setReceiveItems] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);

  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [errors, setErrors] = useState({});

  const [hasSpendsTracking, setHasSpendsTracking] = useState(false);
  const [showAddToProductInventoryModal, setShowAddToProductInventoryModal] = useState(false);
  const [productInventoryItems, setProductInventoryItems] = useState([]);
  const [addToInventoryLoading, setAddToInventoryLoading] = useState(false);

  const primaryInputRefs = useRef([]);
  const galleryInputRefs = useRef([]);

  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnPoItem, setReturnPoItem] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnLoading, setReturnLoading] = useState(false);

  const checkUserType = async () => {
    try {
      const res = await Get("checkUserType");
      const features = res?.matching_features_titles || [];
      setHasSpendsTracking(features.includes("Spends Tracking"));
    } catch {
      setHasSpendsTracking(false);
    }
  };
  useEffect(() => {
    checkUserType();
  }, []);


  const fetchPOList = async ({ page = 1, searchTerm = "" } = {}) => {
    try {
      setLoading(true);
      const response = await GetPaginatedData("productPurchaseOrder", {
        page,
        search: searchTerm || undefined,
      });

      const results = response?.data || [];
      setPoData(results);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      console.error("Fetch error:", error);
      setPoData([]);
      handleToast({ type: "ERROR", message: "Failed to fetch purchase orders" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchPOList({ page: currentPage, searchTerm: debouncedSearchTerm });
  }, [currentPage, debouncedSearchTerm, refreshTrigger]);

  const handleDelete = async (poId) => {
    const result = await confirmDelete("Are you sure?", "You won't be able to revert this!");
    if (!result.isConfirmed) return;

    try {
      await Delete("productPurchaseOrder", poId);
      handleToast({ type: "SUCCESS", message: "Purchase Order deleted successfully" });
      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      handleToast({ type: "ERROR", message: "Failed to delete purchase order" });
    }
  };


  const fetchPoById = async () => {
    if (!viewPoId) return;

    try {
      setLoading(true);

      const res = await Get("productPurchaseOrder");
      const po = res.results.find(p => p.id === viewPoId);

      if (!po) {
        throw new Error("PO not found");
      }

      setPoDetails(po);
    } catch (err) {
      handleToast({
        type: "ERROR",
        message: "Failed to fetch PO details"
      });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (showViewModal && viewPoId) {
      fetchPoById();
    }
  }, [showViewModal, viewPoId]);




  /*============================Receive Variance================*/

  const initializeReceiveItems = (poItems) => {
    return poItems.map(item => ({
      id: item.id,
      product_name: item.product_name,
      specification: item.specification,
      qty: item.qty,
      uom: item.uom,
      uom_title: item.uom_title,
      received_qty: 0,
      damaged_qty: 0,
      excess_qty: 0,
      short_qty: 0,
      is_verified: false
    }));
  };


  const handleReceiveItemChange = (itemId, field, value) => {
    setReceiveItems(prev =>
      prev.map(item => {
        if (item.id !== itemId) return item;

        const ordered = Number(item.qty) || 0;

        if (field === "is_verified") {
          return { ...item, is_verified: value };
        }
        const numericValue = Math.max(0, Number(value) || 0);

        if (field === "received_qty") {
          let excess = 0;
          let short = 0;

          if (numericValue > ordered) {
            excess = numericValue - ordered;
          } else if (numericValue < ordered) {
            short = ordered - numericValue;
          }

          return {
            ...item,
            received_qty: numericValue,
            excess_qty: excess,
            short_qty: short
          };
        }

        if (field === "damaged_qty") {
          return {
            ...item,
            damaged_qty: numericValue
          };
        }

        return {
          ...item,
          [field]: numericValue
        };
      })
    );
  };



  const validateReceiveItems = () => {
    const hasReceivedQty = receiveItems.some(item => item.received_qty > 0);
    if (!hasReceivedQty) {
      handleToast({
        type: "ERROR",
        message: "Please enter received quantity for at least one item"
      });
      return false;
    }

    const allVerified = receiveItems.every(item => item.is_verified);
    if (!allVerified) {
      handleToast({
        type: "ERROR",
        message: "Please verify all items before saving"
      });
      return false;
    }

    return true;
  };


  // Image handlers
  const handlePrimaryImageChange = useCallback((index, file) => {
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setProductInventoryItems(prev => prev.map((item, i) =>
      i === index ? { ...item, primary_image: file, imagePreview: previewUrl } : item
    ));
  }, []);

  const handleRemovePrimaryImage = useCallback((index) => {
    setProductInventoryItems(prev => prev.map((item, i) =>
      i === index ? { ...item, primary_image: null, imagePreview: null } : item
    ));
  }, []);

  const handleGalleryUpload = useCallback((index, files) => {
    const fileArray = Array.from(files);
    const previews = fileArray.map(file => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith('video/') ? 'video' : 'image'
    }));
    setProductInventoryItems(prev => prev.map((item, i) => {
      if (i !== index) return item;
      return {
        ...item,
        gallery_images: [...(item.gallery_images || []), ...fileArray],
        galleryPreview: [...(item.galleryPreview || []), ...previews]
      };
    }));
  }, []);

  const removeGalleryImage = useCallback((itemIndex, imgIndex) => {
    setProductInventoryItems(prev => prev.map((item, i) => {
      if (i !== itemIndex) return item;
      return {
        ...item,
        gallery_images: (item.gallery_images || []).filter((_, idx) => idx !== imgIndex),
        galleryPreview: (item.galleryPreview || []).filter((_, idx) => idx !== imgIndex)
      };
    }));
  }, []);
  const validateProductInventory = () => {
    const newErrors = {};
    let hasError = false;

    productInventoryItems.forEach((item, index) => {
      if (!item.purchase_price || Number(item.purchase_price) <= 0) {
        newErrors[`purchase_price_${index}`] = "Required";
        hasError = true;
      }
      if (!item.selling_price || Number(item.selling_price) <= 0) {
        newErrors[`selling_price_${index}`] = "Required";
        hasError = true;
      }
    });

    setErrors(newErrors);
    if (hasError) {
      handleToast({
        type: "ERROR",
        message: "Please fill all required fields"
      });
    }
    return !hasError;
  };

  const handleReceiveSave = async () => {
    if (!validateReceiveItems()) return;
    setSaveLoading(true);

    try {
      /* ===== VALIDATION FOR INVOICE ===== */
      if (hasSpendsTracking) {
        if (!invoiceNumber || !invoiceAmount) {
          handleToast({
            type: "ERROR",
            message: "Invoice number and amount required"
          });
          setSaveLoading(false);
          return;
        }
      }

      /* ===== PATCH PO ===== */
      const payload = {
        status: "delivered",
        invoice_number: invoiceNumber,
        invoice_amount: Number(invoiceAmount) || 0,
        items: receiveItems.map(item => ({
          id: item.id,
          received_qty: item.received_qty,
          damaged_qty: item.damaged_qty,
          excess_qty: item.excess_qty,
          short_qty: item.short_qty,
          is_verified: item.is_verified
        }))
      };

      await Patch("productPurchaseOrder", receivePoItem.id, payload);

      /* ===== CREATE INVOICE IF ENABLED ===== */
      if (hasSpendsTracking) {
        const invoicePayload = {
          type: "purchase",
          store: receivePoItem.store_id,
          invoice_no: invoiceNumber,
          date: new Date().toISOString().slice(0, 10),
          status: "unpaid",
          pay_method_status: "pay_later",
          pay_method: "pay_later",
          amount: String(invoiceAmount),
          pay_amount: null,
          discount: null,
          remaining_amount: String(invoiceAmount),
          after_discount: null,
          prepaid_tax: false,
          prepaid_tax_percentage: "",
          vendor_department: receivePoItem.vendor,
          vendor_department_name: receivePoItem.vendor_name,
          vendor_department_service_titles: receivePoItem.vendor_name,
          cheque_no: "",
          note: "",
          bank: "",
          days: "0"
        };

        await Post("createInvoiceAndPrepaidTax", invoicePayload);
      }

      /* ===== PREPARE PRODUCT INVENTORY DATA ===== */
      const inventoryData = receiveItems
        .filter(item => item.received_qty > 0)
        .map(item => ({
          title: item.product_name,
          uom: item.uom,
          uom_title: item.uom_title,
          opening_inventory: item.received_qty,
          purchase_price: "",
          selling_price: "",
          total_pc_in_uom: "1",
          barcode: null,
          category: "",
          margin: "",
          primary_image: null,
          imagePreview: null,
          gallery_images: [],
          galleryPreview: []
        }));

      setProductInventoryItems(inventoryData);

      handleToast({
        type: "SUCCESS",
        message: "Products received successfully"
      });

      setShowReceiveModal(false);
      setShowAddToProductInventoryModal(true);

    } catch (error) {
      handleToast({
        type: "ERROR",
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to receive products"
      });
    } finally {
      setSaveLoading(false);
    }
  };


  const updateProductInventoryField = (index, field, value) => {
    setProductInventoryItems(prev =>
      prev.map((item, i) => {
        if (i !== index) return item;

        const updated = { ...item, [field]: value };

        const purchase = Number(updated.purchase_price);
        const margin = Number(updated.margin);

        if (!isNaN(purchase) && !isNaN(margin) && purchase > 0 && margin >= 0) {
          const selling = purchase + (purchase * margin) / 100;
          updated.selling_price = selling.toFixed(2);
        } else {
          updated.selling_price = "";
        }

        return updated;
      })
    );
  };

  // Image refs setup - ensure refs are properly assigned
  useEffect(() => {
    primaryInputRefs.current = productInventoryItems.map(() => null);
    galleryInputRefs.current = productInventoryItems.map(() => null);
  }, [productInventoryItems.length]);
  const receiveSummary = receiveItems.reduce(
    (acc, item) => {
      acc.ordered += Number(item.qty) || 0;
      acc.received += Number(item.received_qty) || 0;
      acc.damaged += Number(item.damaged_qty) || 0;
      acc.excess += Number(item.excess_qty) || 0;
      acc.short += Number(item.short_qty) || 0;
      return acc;
    },
    { ordered: 0, received: 0, damaged: 0, excess: 0, short: 0 }
  );
  const circleBtnStyle = {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    border: "1px solid #e5e7eb",
    background: "#ffffff",
    cursor: "pointer",
    fontWeight: 600
  };

  const handleAddToProductInventory = async () => {
    try {
      setAddToInventoryLoading(true);

      for (const item of productInventoryItems) {
        const formData = new FormData();

        formData.append("store", storeId);
        formData.append("title", item.title);

        formData.append("purchase_price", item.purchase_price);
        formData.append("selling_price", item.selling_price);

        formData.append("short_description", item.short_description || "");
        formData.append("long_description", item.long_description || "");

        formData.append("uom", item.uom);
        formData.append("total_pc_in_uom", item.total_pc_in_uom || 1);

        formData.append("opening_inventory", item.opening_inventory);

        formData.append("vendor", receivePoItem.vendor);
        formData.append("vendor_name", receivePoItem.vendor_name);

        // BARCODE
        if (item.barcode) {
          formData.append("barcode", item.barcode);
        }

        // CATEGORY
        if (item.category?.length) {
          item.category.forEach(c => {
            formData.append("categories", c.id);
          });
        }

        // PRIMARY IMAGE
        if (item.primary_image) {
          formData.append("product_image", item.primary_image);
        }

        // GALLERY
        if (item.gallery_images?.length) {
          item.gallery_images.forEach((img, index) => {
            formData.append(`media_gallery_images[${index}]`, img);
          });
        }

        await PostDataForm("productData", formData);
      }

      handleToast({
        type: "SUCCESS",
        message: "Products added successfully"
      });

      setShowAddToProductInventoryModal(false);
      setProductInventoryItems([]);

    } catch (err) {
      handleToast({
        type: "ERROR",
        message: "Failed to add products"
      });
    } finally {
      setAddToInventoryLoading(false);
    }
  };

  const initializeReturnItems = (poItems) => {
    return poItems
      .filter(item => (item.excess_qty > 0 || item.damaged_qty > 0))
      .map(item => ({
        id: item.id,
        product_name: item.product_name,
        specification: item.specification,
        uom_title: item.uom_title,
        excess_qty: item.excess_qty || 0,
        damaged_qty: item.damaged_qty || 0,
        return_excess_qty: 0,
        return_damaged_qty: 0
      }));
  };

  const handleReturnItemChange = (itemId, field, value) => {
    setReturnItems(prev =>
      prev.map(item => {
        if (item.id !== itemId) return item;
        const numericValue = Math.max(0, Number(value) || 0);
        const maxValue = field === "return_excess_qty" ? item.excess_qty : item.damaged_qty;
        return { ...item, [field]: Math.min(numericValue, maxValue) };
      })
    );
  };


  const handleReturnSubmit = async () => {
    try {
      setReturnLoading(true);

      const apiUrl = getAPI('productExcessReturn').replace('{id}', returnPoItem.id);
      await Post(apiUrl);

      handleToast({
        type: "SUCCESS",
        message: "Return email sent to vendor successfully"
      });

      setShowReturnModal(false);
      setRefreshTrigger(p => p + 1);

    } catch (error) {
      handleToast({
        type: "ERROR",
        message: error?.response?.data?.message || "Failed to send return email"
      });
    } finally {
      setReturnLoading(false);
    }
  };
  const PO_STATUS_PILL = {
    issued: {
      bg: "#fff7ed",
      text: "#c2410c",
      border: "#fed7aa",
    },
    delivered: {
      bg: "#ecfeff",
      text: "#0f766e",
      border: "#99f6e4",
    },
    completed: {
      bg: "#f0fdf4",
      text: "#166534",
      border: "#bbf7d0",
    },
    cancelled: {
      bg: "#fdecec",
      text: "#e11d48",
      border: "#fda4af",
    },
  };
  const BTN = {
    receive: {
      bg: "#ecfeff",
      text: "#0891b2",
      border: "#bae6fd",
      hover: "#cffafe",
    },
    view: {
      bg: "#eef2ff",
      text: "#4338ca",
      border: "#c7d2fe",
      hover: "#e0e7ff",
    },
  };


  const columns = [
    { header: "PO Number", field: "po_number" },
    { header: "Vendor", field: "vendor_name" },
    {
      header: "Status",
      field: "status",
      render: (row) => {
        const cfg = PO_STATUS_PILL[row.status] || PO_STATUS_PILL.issued;

        return (
          <StatusPill
            label={row.status.replace(/_/g, " ")}
            bgColor={cfg.bg}
            textColor={cfg.text}
            borderColor={cfg.border}
          />
        );
      }

    },
    {
      header: "Actions",
      render: (row) => {
        const hasReturnableItems =
          !row.excess_return_email_sent &&   // ✅ hide if already sent
          (row.status === "delivered" || row.status === "completed") &&
          row.po_items?.some(item => (item.excess_qty > 0 || item.damaged_qty > 0));

        return (
          <div>
            {row.status === "issued" && (
              <ActionButton
                onClick={() => {
                  setReceivePoItem(row);
                  setReceiveItems(initializeReceiveItems(row.po_items || []));
                  setShowReceiveModal(true);
                }}
                bgColor={BTN.receive.bg}
                textColor={BTN.receive.text}
                borderColor={BTN.receive.border}
                hoverBgColor={BTN.receive.hover}
              >
                Receive Product
              </ActionButton>
            )}
            {hasReturnableItems && (
              <ActionButton
                onClick={() => {
                  const returnableItems = initializeReturnItems(row.po_items || []);
                  setReturnPoItem(row);
                  setReturnItems(returnableItems);
                  setShowReturnModal(true);
                }}
                bgColor="#fef3c7"
                textColor="#92400e"
                borderColor="#fde68a"
                hoverBgColor="#fef9e7"
              >
                Return Items
              </ActionButton>
            )}
          </div>
        );
      }
    },
    {
      header: "View",
      render: (row) => (
        <ActionButton
          onClick={() => {
            setViewPoId(row.id);
            setShowViewModal(true);
          }}
          bgColor={BTN.view.bg}
          textColor={BTN.view.text}
          borderColor={BTN.view.border}
          hoverBgColor={BTN.view.hover}
        >
          View
        </ActionButton>
      )
    }

  ];

  return (
    <div id="inventory-po-container" className="responsive-box">
      <div id="inventory-header" className="inventory-header">
        <div id="inventory-title" className="inventory-title">Purchase Order Management</div>
        <div id="btn-position" className="btn-position">
        </div>

      </div>
      <ReusableModal
        id="view-po-modal"
        title="Purchase Order Details"
        show={showViewModal}
        handleClose={() => {
          setShowViewModal(false);
          setViewPoId(null);
          setPoDetails(null);
        }}
        width="900px"
      >
        {loading && <p id="loading-text">Loading...</p>}

        {poDetails && (
          <div id="po-view-container" className="po-view-container">
            {/* ===== PO META SECTION ===== */}
            <div id="po-view-meta" className="po-view-meta">
              <div id="po-meta-left" className="po-meta-left">
                <div id="po-meta-item-number" className="po-meta-item">
                  <span id="po-meta-label-number" className="po-meta-label">PO Number</span>
                  <span id="po-meta-value-number" className="po-meta-value">{poDetails.po_number}</span>
                </div>

                <div id="po-meta-item-vendor" className="po-meta-item">
                  <span id="po-meta-label-vendor" className="po-meta-label">Vendor</span>
                  <span id="po-meta-value-vendor" className="po-meta-value">{poDetails.vendor_name}</span>
                </div>

                <div id="po-meta-item-status" className="po-meta-item">
                  <span id="po-meta-label-status" className="po-meta-label">Status</span>
                  <span id={`po-status-badge-${poDetails.status}`} className={`po-status-badge po-status-${poDetails.status}`}>
                    {poDetails.status?.charAt(0).toUpperCase() + poDetails.status?.slice(1)}
                  </span>

                </div>
              </div>

              <div id="po-meta-right" className="po-meta-right">
                <div id="po-meta-item-rfq-name" className="po-meta-item">
                  <span id="po-meta-label-rfq-name" className="po-meta-label">RFQ Name</span>
                  <span id="po-meta-value-rfq-name" className="po-meta-value">
                    {poDetails.rfq_name || "N/A"}
                  </span>
                </div>

                <div id="po-meta-item-rfq-number" className="po-meta-item">
                  <span id="po-meta-label-rfq-number" className="po-meta-label">RFQ Number</span>
                  <span id="po-meta-value-rfq-number" className="po-meta-value">
                    {poDetails.rfq_number || "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* ===== PO ITEMS ===== */}
            <div id="po-items-section" className="po-items-section">
              <div id="po-items-header" className="po-items-header">
                <span id="po-header-product">PRODUCT</span>
                <span id="po-header-specification">SPECIFICATION</span>
                <span id="po-header-uom">UOM</span>
                <span id="po-header-ordered" className="po-items-qty" style={{ color: "#3b82f6", fontWeight: "700" }}>Ordered</span>
                <span id="po-header-received" className="po-items-qty" style={{ color: "#10b981", fontWeight: "700" }}>Received</span>
                <span id="po-header-damaged" className="po-items-qty" style={{ color: "#ef4444", fontWeight: "700" }}>Damaged</span>
                <span id="po-header-excess" className="po-items-qty" style={{ color: "#f59e0b", fontWeight: "700" }}>Excess</span>
                <span id="po-header-short" className="po-items-qty" style={{ color: "#dc2626", fontWeight: "700" }}>Short</span>
              </div>

              {poDetails.po_items && poDetails.po_items.length > 0 ? (
                poDetails.po_items.map(item => (
                  <div id={`po-item-row-${item.id}`} className="po-items-row" key={item.id}>
                    <span id={`po-item-name-${item.id}`}>{item.product_name}</span>
                    <span id={`po-item-spec-${item.id}`}>{item.specification}</span>
                    <span id={`po-item-uom-${item.id}`}>{item.uom_title || "-"}</span>
                    <span id={`po-item-qty-${item.id}`} className="po-items-qty qty-ordered">{item.qty}</span>
                    <span id={`po-item-received-${item.id}`} className="po-items-qty qty-received">{item.received_qty ?? 0}</span>
                    <span id={`po-item-damaged-${item.id}`} className="po-items-qty qty-damaged">{item.damaged_qty ?? 0}</span>
                    <span id={`po-item-excess-${item.id}`} className="po-items-qty qty-excess">{item.excess_qty ?? 0}</span>
                    <span id={`po-item-short-${item.id}`} className="po-items-qty qty-short">{item.short_qty ?? 0}</span>
                  </div>
                ))
              ) : (
                <div id="po-items-empty" className="po-items-empty">No items</div>
              )}
            </div>



          </div>
        )}

      </ReusableModal>
      {/* /*========================Receive Variance========================*/}
      <ReusableModal
        id="receive-variance-modal"
        title="Receive Product"
        show={showReceiveModal}
        handleClose={() => {
          setShowReceiveModal(false);
          setReceivePoItem(null);
        }}
        width="1200px"
      >
        {receivePoItem && (
          <div id="rv-po-info" className="rv-po-info">
            <div id="rv-po-info-item-number" className="rv-po-info-item">
              <span id="rv-label-po-number" className="rv-label">PO Number</span>
              <span id="rv-value-po-number" className="rv-value">{receivePoItem.po_number}</span>
            </div>

            <div id="rv-po-info-item-rfq-number" className="rv-po-info-item">
              <span id="rv-label-rfq-number" className="rv-label">RFQ Number</span>
              <span id="rv-value-rfq-number" className="rv-value">{receivePoItem.rfq_number}</span>
            </div>

            <div id="rv-po-info-item-rfq-name" className="rv-po-info-item">
              <span id="rv-label-rfq-name" className="rv-label">RFQ Name</span>
              <span id="rv-value-rfq-name" className="rv-value">{receivePoItem.rfq_name}</span>
            </div>

            <div id="rv-po-info-item-vendor" className="rv-po-info-item">
              <span id="rv-label-vendor" className="rv-label">Vendor</span>
              <span id="rv-value-vendor" className="rv-value">{receivePoItem.vendor_name}</span>
            </div>
          </div>
        )}
        {/* {hasSpendsTracking && ( */}
        <div id="rv-invoice-section" className="rv-invoice-section">
          <div id="rv-invoice-item-number" className="rv-invoice-item">

            <ReusableInput
              id="invoiceNumber"
              name="invoiceNumber"
              type="text"
              label="Invoice Number"
              value={invoiceNumber}
              onChange={e => setInvoiceNumber(e.target.value)}
              style={{ width: "250px" }}
            />
          </div>

          <div id="rv-invoice-item-amount" className="rv-invoice-item">
            <ReusableInput
              id="invoice-amount"
              name="invoice-amount"
              type="number"
              value={invoiceAmount}
              label="Invoice Amount"
              onChange={e => setInvoiceAmount(e.target.value)}
              style={{ width: "250px" }}
            // required={hasSpendsTracking}
            />
          </div>
        </div>

        <div id="receive-variance-table" className="receive-variance-table">
          <div id="receive-variance-header" className="receive-variance-header">
            <span id="rv-header-item">Product Name</span>
            <span id="rv-header-uom" className="rv-center">Uom</span>
            <span id="rv-header-ordered" className="rv-center" style={{ color: "#3b82f6", fontWeight: "700" }}>Ordered</span>
            <span id="rv-header-received" className="rv-center" style={{ color: "#10b981", fontWeight: "700" }}>Received</span>
            <span id="rv-header-damaged" className="rv-center" style={{ color: "#ef4444", fontWeight: "700" }}>Damaged</span>
            <span id="rv-header-excess" className="rv-center" style={{ color: "#f59e0b", fontWeight: "700" }}>Excess</span>
            <span id="rv-header-short" className="rv-center" style={{ color: "#dc2626", fontWeight: "700" }}>Short</span>
            <span id="rv-header-verify" className="rv-center">Verify</span>
          </div>

          {receiveItems.map(item => (
            <div id={`receive-variance-row-${item.id}`} className="receive-variance-row" key={item.id}>
              <div id={`rv-item-${item.id}`} className="rv-item">
                <div id={`rv-name-${item.id}`} className="rv-name">{item.product_name}</div>
                <div id={`rv-sku-${item.id}`} className="rv-sku">{item.specification}</div>
              </div>
              <span id={`rv-uom-${item.id}`} className="rv-center rv-uom">{item.uom_title}</span>
              <span id={`rv-qty-${item.id}`} className="rv-center qty-ordered">{item.qty}</span>


              <ReusableInput
                id={`received-qty-${item.id}`}
                name={`received-qty-${item.id}`}
                type="number"
                value={item.received_qty}
                onChange={e =>
                  handleReceiveItemChange(item.id, "received_qty", e.target.value)
                }
                style={{ width: "80px", color: "#34d399", fontWeight: "600" }}
              />

              <ReusableInput
                id={`damaged-qty-${item.id}`}
                name={`damaged-qty-${item.id}`}
                type="number"
                value={item.damaged_qty}
                onChange={e =>
                  handleReceiveItemChange(item.id, "damaged_qty", e.target.value)
                }
                style={{ width: "80px", color: "#f87171", fontWeight: "600" }}
              />

              <ReusableInput
                id={`excess-qty-${item.id}`}
                name={`excess-qty-${item.id}`}
                type="number"
                value={item.excess_qty}
                onChange={e =>
                  handleReceiveItemChange(item.id, "excess_qty", e.target.value)
                }
                style={{ width: "80px", color: "#fbbf24", fontWeight: "600" }}
              />

              <ReusableInput
                id={`short-qty-${item.id}`}
                name={`short-qty-${item.id}`}
                type="number"
                value={item.short_qty}
                onChange={e =>
                  handleReceiveItemChange(item.id, "short_qty", e.target.value)
                }
                style={{ width: "80px", color: "#fb923c", fontWeight: "600" }}
              />

              <div
                id={`verify-container-${item.id}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px"
                }}
              >
                <div
                  onClick={() =>
                    handleReceiveItemChange(item.id, "is_verified", !item.is_verified)
                  }
                  style={{
                    width: "50px",
                    height: "26px",
                    borderRadius: "13px",
                    backgroundColor: item.is_verified ? "rgba(16, 185, 129, 0.2)" : "rgba(209, 213, 219, 0.3)",
                    position: "relative",
                    cursor: "pointer",
                    transition: "all 0.3s",
                    border: item.is_verified ? "2px solid rgba(5, 150, 105, 0.5)" : "2px solid rgba(156, 163, 175, 0.4)"
                  }}
                >
                  <div
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: item.is_verified ? "#10b981" : "#9ca3af",
                      position: "absolute",
                      top: "2px",
                      left: item.is_verified ? "26px" : "2px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.15)"
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: item.is_verified ? "#10b981" : "#6b7280"
                  }}
                >
                  {item.is_verified ? "✓" : ""}
                </span>
              </div>
            </div>
          ))}
          <div className="rv-summary-vertical">
            <div className="rv-summary-row">
              <span>TOTAL ORDERED</span>
              <span className="rv-val ordered">{receiveSummary.ordered}</span>
            </div>

            <div className="rv-summary-row">
              <span>TOTAL RECEIVED</span>
              <span className="rv-val received">{receiveSummary.received}</span>
            </div>

            <div className="rv-summary-row">
              <span>TOTAL DAMAGED</span>
              <span className="rv-val damaged">{receiveSummary.damaged}</span>
            </div>

            <div className="rv-summary-row">
              <span>TOTAL EXCESS</span>
              <span className="rv-val excess">{receiveSummary.excess}</span>
            </div>

            <div className="rv-summary-row">
              <span>TOTAL SHORT</span>
              <span className="rv-val short">{receiveSummary.short}</span>
            </div>

          </div>
          <div id="rv-footer" className="rv-footer">
            <RegularButton
              id="save-all-items-btn"
              text={saveLoading ? "Saving..." : "Save All Items"}
              onClick={handleReceiveSave}
              backgroundColor="#282e26"
              disabled={saveLoading}
            />
          </div>
        </div>
      </ReusableModal>
      <ReusableModal
        id="add-to-product-inventory-modal"
        title="Add To Product Inventory"
        show={showAddToProductInventoryModal}
        handleClose={() => setShowAddToProductInventoryModal(false)}
        width="1200px"
      >
        <div id="product-inventory-container" style={{ padding: "20px" }}>

          {productInventoryItems.map((item, index) => (
            <div
              id={`product-inventory-item-${index}`}
              key={index}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "14px",
                padding: "20px",
                marginBottom: "20px",
                // background: "#f9fafb"
              }}
            >

              {/* ===== TOP HEADER ===== */}
              <div
                id={`product-header-${index}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px"
                }}
              >
                <div id={`product-info-${index}`} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    id={`product-icon-${index}`}
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      background: "#eef2ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#4f46e5",
                      fontSize: "22px"
                    }}
                  >
                    <FiPackage />
                  </div>

                  <div id={`product-details-${index}`}>
                    <div id={`product-title-${index}`} style={{ fontWeight: 600, fontSize: "16px" }}>
                      {item.title}
                    </div>
                    <div id={`product-uom-${index}`} style={{ fontSize: "12px", color: "#000000" }}>
                      UOM: {item.uom_title}
                    </div>
                  </div>
                </div>

                {/* ===== RECEIVED QUANTITY BADGE ===== */}
                <div id={`product-qty-badge-${index}`} style={{ textAlign: "right" }}>
                  <div id={`product-qty-label-${index}`} style={{ fontSize: "11px", color: "#000000" }}>
                    RECEIVED QUANTITY
                  </div>
                  <div
                    id={`product-qty-value-${index}`}
                    style={{
                      marginTop: "5px",
                      background: "#dcfce7",
                      color: "#166534",
                      padding: "6px 14px",
                      borderRadius: "20px",
                      fontWeight: 600,
                      display: "inline-block"
                    }}
                  >
                    {item.opening_inventory}
                  </div>
                </div>
              </div>

              {/* ===== MAIN CONTENT GRID ===== */}
             <div className="product-layout">
                {/* LEFT: Inputs */}
              <div className="left-section">
                
                <div className="price-row">
                    <ReusableInput
                      id={`purchase-price-${index}`}
                      name={`purchase-price-${index}`}
                      type="number"
                      label="Purchase Price"
                      value={item.purchase_price}
                      style={{ width: "220px" }}
                      onChange={e =>
                        updateProductInventoryField(index, "purchase_price", e.target.value)
                      }
                      required
                      error={errors[`purchase_price_${index}`]}
                    />
                     <div className="margin-box">
                      <label style={{ fontSize: "12px", fontWeight: 500 }}>
                        MARGIN (%)
                      </label>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginTop: "6px"
                        }}
                      >
                        {/* Minus */}
                        <button
                          type="button"
                          onClick={() =>
                            updateProductInventoryField(
                              index,
                              "margin",
                              Math.max(0, (Number(item.margin) || 0) - 1)
                            )
                          }
                          style={circleBtnStyle}
                        >
                          -
                        </button>

                        {/* Percentage Display */}
                        <input
                          type="number"
                          min="0"
                          max="100"
                          value={item.margin || ""}
                          onChange={(e) =>
                            updateProductInventoryField(index, "margin", e.target.value)
                          }
                          style={{
                            flex: 1,
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            padding: "4px 10px",
                            textAlign: "center",
                            fontWeight: 600,
                            background: "#f3f4f6"
                          }}
                        />

                        {/* Plus */}
                        <button
                          type="button"
                          onClick={() =>
                            updateProductInventoryField(
                              index,
                              "margin",
                              (Number(item.margin) || 0) + 1
                            )
                          }
                          style={circleBtnStyle}
                        >
                          +
                        </button>
                      </div>

                      {/* Slider */}
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={item.margin}
                        onChange={e =>
                          updateProductInventoryField(index, "margin", e.target.value)
                        }
                        style={{
                          width: "100%",
                          marginTop: "10px"
                        }}
                      />
                    </div>

                    <ReusableInput
                      id={`selling-price-${index}`}
                      name={`selling-price-${index}`}
                      type="number"
                      label="Selling Price"
                      value={item.selling_price}
                      style={{ width: "220px" }}
                      onChange={e =>
                        updateProductInventoryField(index, "selling_price", e.target.value)
                      }
                      required
                      error={errors[`selling_price_${index}`]}
                    />


                    <PaginatedMultiSelect
                      api="productCategory"
                      GetPaginatedData={GetPaginatedData}
                      getOptionLabel={(opt) => opt.name}
                      value={item.category}
                      onSelect={(val) =>
                        updateProductInventoryField(index, "category", val)
                      }
                      placeholder="Select Category"
                    />
                    <div style={{position: "relative"}}>
                    <PaginatedSearchSelect
                      api="getWeight"
                      GetPaginatedData={GetPaginatedData}
                      getOptionLabel={(opt) => opt.weight_title}
                      value={item.weight_unit}
                      onSelect={(val) =>
                        updateProductInventoryField(index, "weight_unit", val)
                      }
                      placeholder="Weight Unit"
                    />
</div>
                    {/* WEIGHT */}

                    <ReusableInput
                      type="number"
                      label="Weight"
                      value={item.weight_value}
                      onChange={(e) =>
                        updateProductInventoryField(index, "weight_value", e.target.value)
                      }
                    />

                    {/* SHORT DESC */}
                    <ReusableInput
                      label="Short Description"
                      value={item.short_description}
                      onChange={(e) =>
                        updateProductInventoryField(index, "short_description", e.target.value)
                      }
                    />

                    {/* LONG DESC */}
                    <textarea
                      placeholder="Long Description"
                      value={item.long_description}
                      onChange={(e) =>
                        updateProductInventoryField(index, "long_description", e.target.value)
                      }
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "8px"
                      }}
                    />

                    {/* BARCODE CHECKBOX */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <input
                        type="checkbox"
                        checked={item.autoGenerateBarcode}
                        onChange={(e) =>
                          updateProductInventoryField(index, "autoGenerateBarcode", e.target.checked)
                        }
                      />
                      <label>Auto Generate Barcode</label>
                    </div>

                    {/* BARCODE FIELD */}
                    {!item.autoGenerateBarcode && (
                      <ReusableInput
                        label="Barcode"
                        value={item.barcode}
                        onChange={(e) =>
                          updateProductInventoryField(index, "barcode", e.target.value)
                        }
                      />
                    )}
                  </div>

                  {/* RIGHT: Image Upload Section */}
              
                </div>
                 <div className="right-section">
                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#111827', marginBottom: '8px' }}>
                      Primary Image & Gallery
                    </div>

                    {/* Primary Image */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '12px',
                      background: '#f8fafc',
                      padding: '18px',
                      borderRadius: '18px',
                      border: '1px solid #dbeafe'
                    }}>
                      <div style={{ fontSize: '14px', color: '#374151', marginTop: '8px' }}>
                        Primary Image
                      </div>
                      <div
                        className="primary-image-box"
                        style={{
                          width: '140px',
                          height: '140px',
                          borderRadius: '18px',
                          border: '2px dashed #cbd5e1',
                          background: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                        onClick={() => primaryInputRefs.current[index]?.click()}
                      >
                        {item.imagePreview ? (
                          <>
                            <img
                              src={item.imagePreview}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                            />
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemovePrimaryImage(index);
                              }}
                              style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                background: 'rgba(0,0,0,0.6)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                fontSize: '14px'
                              }}
                            >
                              ×
                            </button>
                          </>
                        ) : (
                          <span style={{ fontSize: '30px', color: '#9aa0a6' }}>+</span>
                        )}
                      </div>
                      <input
                        ref={(el) => { if (el) primaryInputRefs.current[index] = el; }}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handlePrimaryImageChange(index, e.target.files?.[0])}
                        style={{ display: 'none' }}
                      />
                    </div>

                    {/* Gallery */}
                    <input
                      ref={(el) => { if (el) galleryInputRefs.current[index] = el; }}
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      onChange={(e) => handleGalleryUpload(index, e.target.files)}
                      style={{ display: 'none' }}
                    />
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: '10px', marginTop: '10px' }} className="gallery-grid">
                      {(item.galleryPreview || []).map((media, gIndex) => (
                        <div key={gIndex} style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '12px',
                          overflow: 'hidden',
                          border: '1px solid #d1d5db',
                          position: 'relative',
                          background: '#ffffff'
                        }} className="gallery-item">
                          {media.type === 'image' ? (
                            <img src={media.url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} className="gallery-media" />
                          ) : (
                            <video src={media.url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} className="gallery-media" />
                          )}
                          <button
                            type="button"
                            onClick={() => removeGalleryImage(index, gIndex)}
                            style={{
                              position: 'absolute',
                              top: '6px',
                              right: '6px',
                              background: 'rgba(0,0,0,0.65)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              width: '18px',
                              height: '18px',
                              fontSize: '12px',
                              cursor: 'pointer'
                            }}
                            className="gallery-remove-btn"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                      <div
                        style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '12px',
                          border: '2px dashed #cfcfcf',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          background: '#f6f6f6'
                        }}
                        className="gallery-add-box"
                        onClick={() => galleryInputRefs.current[index]?.click()}
                      >
                        <span style={{ fontSize: '30px', color: '#9aa0a6' }}>+</span>
                      </div>
                    </div>
                  </div>
                {/* </div> */}
              </div>
            </div>
          ))}

          <div id="product-inventory-submit-container" style={{ display: "flex", justifyContent: "flex-end" }}>
            <RegularButton
              id="submit-product-inventory-btn"
              text={addToInventoryLoading ? "Submitting..." : "Submit"}
              onClick={handleAddToProductInventory}
              backgroundColor="#111827"
              disabled={addToInventoryLoading}
            />
          </div>

        </div>
      </ReusableModal>

      <ReusableModal
        id="return-items-modal"
        title="Return Excess/Damaged Items"
        show={showReturnModal}
        handleClose={() => {
          setShowReturnModal(false);
          setReturnPoItem(null);
        }}
        width="1000px"
      >
        {returnPoItem && (
          <div className="return-container">
            <div className="return-po-info">
              <div>
                <span className="return-label">PO Number</span>
                <span className="return-value">{returnPoItem.po_number}</span>
              </div>
              <div>
                <span className="return-label">Vendor</span>
                <span className="return-value">{returnPoItem.vendor_name}</span>
              </div>
            </div>

            <div className="return-table">
              <div className="return-header">
                <span>Product</span>
                <span className="return-col-center">Excess Qty</span>
                <span className="return-col-center">Damaged Qty</span>
              </div>

              {returnItems.map(item => (
                <div key={item.id} className="return-row">
                  <div className="return-product">
                    <div className="return-name">{item.product_name}</div>
                    <div className="return-spec">{item.specification}</div>
                  </div>
                  <span className="return-excess text-center">{item.excess_qty}</span>
                  <span className="return-damaged text-center">{item.damaged_qty}</span>
                </div>
              ))}
            </div>

            <div className="return-footer">
              <RegularButton
                text={returnLoading ? "Sending..." : "Send to Vendor"}
                onClick={handleReturnSubmit}
                backgroundColor="#111827"
                disabled={returnLoading}
              />
            </div>
          </div>
        )}
      </ReusableModal>

      <AssetTable
        id="po-asset-table"
        data={poData}
        columns={columns}
        loading={loading}
        showAction={true}
        // onEdit={handleEdit}
        onDelete={handleDelete}
        showFooter
        currentPage={currentPage}
        totalCount={totalCount}
        onPageChange={setCurrentPage}
        searchTerm={searchTerm}
        onSearch={setSearchTerm}
      />
    </div>
  );
};

export default InventoryPO







